/**
 * Standardwerte des Aura-Systems fuer die Anzeige im Frontend.
 *
 * WICHTIG: Gerechnet wird die Aura ausschliesslich im Backend
 * (backend/src/services/AuraSystem.js). Diese Datei liefert nur noch Fallback-Zahlen
 * fuer die Darstellung, falls GET /api/v1/aura/config nicht erreichbar ist - die
 * echten Werte einer Schule kommen von dort.
 *
 * Bis August 2026 stand hier zusaetzlich eine komplette Schatten-Berechnung
 * (Klasse AuraSystem + Singleton `auraSystem`) mit eigener Fokus-Bonus-Logik.
 * Sie hatte keinen produktiven Aufrufer mehr und ist entfallen; ebenso der
 * Fokus-Bonus selbst, weil der Fokus-Modus nur noch solo laeuft und keine Aura gibt.
 *
 * Werte spiegeln backend/src/constants/auraDefaults.js.
 */
export const AURA_CONFIG = {
  // Level-Grenzen
  levelThresholds: {
    1: 0,      // Anfänger: 0-499 Punkte
    2: 500,    // Helfer: 500-999 Punkte
    3: 1000,   // Mentor: 1000-1999 Punkte
    4: 2000,   // Meister: 2000-4999 Punkte
    5: 5000    // Weiser: 5000+ Punkte
  },

  // Tägliche Limits
  limits: {
    dailySessionLimit: 3,      // Max. 3 Sessions pro Tag
    dailyMinuteLimit: 90,      // Max. 90 Minuten pro Tag
    minSessionDuration: 10,    // Min. 10 Minuten pro Session (darunter keine Aura)
    maxSessionDuration: 90     // Max. 90 Minuten pro Session (Deckel fuer die Aura, wie im Backend)
  },

  // Belohnungssystem
  rewards: {
    sessionBase: 1,            // 1 Punkt pro Minute
    hostBonus: 0.2,            // +20% als Host
    dailyLogin: {
      base: 10,                // 10 Punkte für tägliches Login
      streakBonus: [0, 5, 5, 10, 10], // Zusätzliche Punkte für Login-Streak
      streakPause: 2           // 2 Tage Pause erlaubt
    }
  }
};
